import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M16.417 16H3.583c-.322 0-.583.28-.583.625v3.75c0 .345.261.625.583.625h12.834c.322 0 .583-.28.583-.625v-3.75c0-.345-.261-.625-.583-.625zM16 20H4v-3h12v3zm2.5-4c.276 0 .5.28.5.625v3.75c0 .345-.224.625-.5.625s-.5-.28-.5-.625v-3.75c0-.345.224-.625.5-.625zm2 0c.276 0 .5.28.5.625v3.75c0 .345-.224.625-.5.625s-.5-.28-.5-.625v-3.75c0-.345.224-.625.5-.625zm-1-4c.827 0 1.5.673 1.5 1.5v1a.5.5 0 0 1-1 0v-1c0-.28-.22-.5-.5-.5h-3c-.827 0-1.5-.673-1.5-1.5s.678-1.5 1.51-1.5h1.98c.281 0 .51-.224.51-.5 0-.271-.226-.5-.495-.5h-8.009a1.5 1.5 0 1 1 .012-3h6.483a.5.5 0 1 0 0-1H12.5a.5.5 0 0 1 0-1h4.491c.832 0 1.509.673 1.509 1.5S17.823 7 16.991 7h-6.483a.511.511 0 0 0-.508.5c0 .28.218.5.496.5h8.009a1.5 1.5 0 1 1-.015 3h-1.98a.5.5 0 1 0-.01 1h3zm-12-7a.5.5 0 0 1 0-1h3a.5.5 0 0 1 0 1h-3zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"
});

var SvgTobacco = function SvgTobacco(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgTobacco;